import WidgetWrapper from "../../../components/Widgets/WidgetWrapper";
import { Grid, GridItem, Flex, Text } from "@chakra-ui/react";
import TicketForm from "../../../components/Tickets";
import { useLocation } from "react-router-dom";

const Boka = () => {
  return (
    <Grid gap={"20px"} marginBottom={"auto"}>
      <GridItem>
        <WidgetWrapper child={<TicketForm title="Boka Möte" />} />
      </GridItem>
    </Grid>
  );
};

export default Boka;
